import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="mx-auto max-w-3xl px-5 py-16 md:px-12 md:py-24">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37]">
          Legal
        </p>
        <h1 className="mt-3 text-4xl font-bold tracking-tight sm:text-5xl">
          Privacy Policy
        </h1>
        <p className="mt-3 text-sm text-zinc-400">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <div className="prose prose-invert mt-10 max-w-none text-zinc-300">
          <p>
            Capital Access Hub ("we", "our", "us") respects your privacy. This
            policy describes what information we collect, how we use it, and the
            choices you have.
          </p>

          <h2 className="mt-8 text-2xl font-semibold text-white">Information We Collect</h2>
          <p>
            When you submit our funding application form we collect the
            information you provide, including your name, email, phone number,
            business name, monthly revenue range, time in business, and credit
            range.
          </p>

          <h2 className="mt-8 text-2xl font-semibold text-white">How We Use Your Information</h2>
          <p>
            We use the information you provide to evaluate your funding eligibility
            and to share your application with vetted funding partners who may
            contact you about funding programs.
          </p>

          <h2 className="mt-8 text-2xl font-semibold text-white">Disclaimer</h2>
          <p>
            Capital Access Hub is not a lender. We connect businesses with funding
            partners. Approval and final terms are determined solely by the partner.
          </p>

          <h2 className="mt-8 text-2xl font-semibold text-white">Contact</h2>
          <p>
            Questions? Email us at{" "}
            <a className="text-[#D4AF37] hover:underline" href="mailto:funding@meltedportstudios.com">
              funding@meltedportstudios.com
            </a>
            .
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
